import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import { Button, CardContent, MenuItem, Select } from "@material-ui/core";
import { Form } from "react-bootstrap";

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "goods",
      question: "",
      que_type:"",
      isEdit: false,
      addCategory: false,
      questionData: null
    };
  }

  componentDidMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    let questionId = this.props.match.params.id;
    // let questionId = window.location.pathname.split("/")[3];
    // debugger;
    let isEdit = window.location.pathname.split("/")[2] === "editQuestion";

    let addCategory = window.location.pathname.split("/")[2] === "addQuestion";
    // console.log(isEdit, window.location.pathname.split("/")[2], addCategory);
    this.setState({ isEdit, addCategory });
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    axios
      .get(`${domain}/setting/questions/${questionId}`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          this.setState({
            questionData: res.data.data,
            title: res.data.data.title,
            question: res.data.data.name,
            que_type:res.data.data.que_type
          });
        }
      })
      .catch((error) => { });
  };

  submitForm = (e) => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    e.preventDefault();
    let body = {
      title: this.state.title,
      name: this.state.question,
    };
    if (this.state.isEdit) {
      let questionData = this.state.questionData;
      console.log(e);
      axios
        .put(`${domain}/setting/questions/${questionData._id}`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Question Updated Successfully!")
            this.props.history.goBack();
          }
        })
        .catch((error) => { });
    } else {
      console.log(e);
      body={...body,
        que_type:this.state.que_type,
      }
      axios
        .post(`${domain}/setting/questions`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Question Added Successfully!")
            this.props.history.goBack();
          }
        })
        .catch((error) => { });
    }
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  render() {
    const { isEdit, addCategory,que_type, title, question } = this.state;
    return (
      <div>
        <Card>
          <CardContent>
            <Form onSubmit={this.submitForm}>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="title"
                  id="title"
                  label="Title"
                  type="name"
                  disabled={true}
                  onChange={this.handleChange}
                  fullWidth
                  value={title}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="question"
                  id="question"
                  label="Question"
                  type="name"
                  disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={question}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  
                  autoFocus
                  margin="dense"
                  name="que_type"
                  id="que_type"
                  label="Question Type"
                  type="name"
                  disabled={ !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={que_type}
                  style={{ marginBottom: "20px" }}
                  required
                  select
                ><MenuItem value="input">{"Input Type"}</MenuItem>
                <MenuItem value="boolean">{"Boolean Type"}</MenuItem></TextField>
              </GridItem>
              <GridItem xs={12} className="new_Card">
                {(addCategory || isEdit) && (
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                )}
              </GridItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
